var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from "lodash";
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var PostControllerAsset3D = /** @class */ (function () {
    function PostControllerAsset3D() {
    }
    /*****************************************************************************************************
        * Is using route "api/post/Asset3D" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {Asset3DUploadDto} data
        * @param {{[key: string]: File}} overlayMedia
        * @param {File} models3D
        * @returns {CommunityFeedPostDownloadDto}
    ******************************************************************************************************/
    PostControllerAsset3D.PostAsset3D = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        _.forEach(data.overlayMedia, function (val, key) { return fd.append(key, val); });
        if (data.models3D)
            fd.append("models3D", data.models3D);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/Asset3D", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{groupid}/Asset3D/{lng}/trie" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @param {string} lng
        * @returns {ExtendedDataCollection<Asset3DDownloadDto, Node<string>>}
    ******************************************************************************************************/
    PostControllerAsset3D.GetAsset3DWithTire = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{groupid}/Asset3D/{lng}/trie", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/Asset3D/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} media
        * @param {Asset3DUploadDto} data
        * @param {{[key: string]: File}} overlayMedia
        * @param {File} models3D
        * @returns {CommunityFeedPostDownloadDto}
    ******************************************************************************************************/
    PostControllerAsset3D.PatchAsset3D = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        _.forEach(data.overlayMedia, function (val, key) { return fd.append(key, val); });
        if (data.models3D)
            fd.append("models3D", data.models3D);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/Asset3D/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    return PostControllerAsset3D;
}());
export { PostControllerAsset3D };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=PostControllerAsset3D.js.map